<template>
  <div class="pb-14 mb-14">
    <v-btn small class="mx-4" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn>

    <h4 class="text-center">Agrupadores</h4>
    <v-progress-linear v-if="loading" indeterminate />
    <div class="text-right mr-2 mb-2">
      <v-btn
        small
        class=""
        @click="$refs.createmodal.openmodal()()"
        color="green"
        tile
        outlined
        v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 14">
        <v-icon left small>mdi-folder-plus</v-icon> Registrar Agrupador
      </v-btn>
    </div>

    <v-data-table
      :headers="headers"
      :items="promociones"
      disable-pagination
      hide-default-footer
      :itemsPerPage="-1"
      class="elevation-2">
      <template v-slot:[`item.estudiante`]="{ item }">
        <span>
          {{ item.estudiante.primer_apellido }} {{ item.estudiante.segundo_apellido }}
          {{ item.estudiante.nombres }}
        </span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip bottom v-if="item.inscritos != 0">
          <template #activator="{ on, attrs }">
            <v-icon class="orange--text mr-2" v-bind="attrs" v-on="on" @click="$refs.createmodal.openmodal(item)">
              mdi-pencil
            </v-icon>
          </template>
          Visualizar datos
        </v-tooltip>
        <!-- <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon class="red--text mr-2" v-bind="attrs" v-on="on" @click="preEliminacion(item)">
              mdi-clipboard-check-multiple
            </v-icon>
          </template>
          Eliminar
        </v-tooltip> -->
      </template>
    </v-data-table>

    <div>
      <Create ref="createmodal" v-on:onnew="onnew" />
    </div>
    <div>
      <Viewp ref="viewmodal" />
    </div>
  </div>
</template>

<script>
  import Create from '@/views/agrupadores/agregar.vue';
  import Viewp from '@/views/promociones/promo-view.vue';
  import { getdataeliminar } from '@/views/promociones/util.js';
  import xaxios from '@/xaxios';
  export default {
    data: () => ({
      loading: false,
      promociones: [{}],
      posgrado: null,
      headers: [
        { text: 'ID', value: 'id', width: 20 },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Orden', value: 'orden', width: 120 },
        { text: 'Acciones', value: 'actions', width: 130 },
      ],
    }),

    components: { Create, Viewp },
    computed: {},
    watch: {},
    methods: {
      onnew() {
        this.getpromos();
      },
      getpromos() {
        this.loading = true;
        let vue = this;
        this.promociones = [];
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/agrupadores`,
          headers: {},
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            window.console.log(data);
            vue.promociones = data.reverse();
            vue.loading = false;
          })
          .catch(function (error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
      preEliminacion(item) {
        let vue = this;
        let dat = getdataeliminar();
        this.$dialog
          .confirm(dat.message, dat.options)
          .then(function (dialog) {
            vue.eliminar(item, dialog);
            dialog.close();
          })
          .catch(function () {});
      },
      eliminar(item, dialog) {
        let vue = this;
        var config = {
          method: 'delete',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/agrupadores/${item.id}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function (response) {
            let data = response.data.data;
            window.console.log(data);
            vue.getpromos();
            dialog.close();
          })
          .catch(function (error) {
            window.console.log(error);
            dialog.close();
          });
      },
    },
    mounted() {
      this.getpromos();
    },
  };
</script>
